import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=4ec17049&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=ts&"
export * from "./Certificate.vue?vue&type=script&lang=ts&"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=4ec17049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec17049",
  null
  
)

export default component.exports